export default __webpack_public_path__ + "static/media/processing.12ce78a7.gif";